module.exports = __webpack_public_path__ + "static/media/manualpqr.e201fb5c.pdf";